export const STARTER_COPY = {
    LIST_TITLE: 'Starters',
    CREATE: 'Create starter',
    CARD_PUBLISHED: 'Published',
    CARD_PUBLISHED_CAPTION: 'Starters any shop can copy.',
    CARD_EVERY: 'Every state',
    CARD_EVERY_CAPTION: 'Starters with no state list, open to a shop in any state.',
    CARD_DASH: 'Dashboard sign-in',
    CARD_DASH_CAPTION: 'Starters that let a person sign in to the business dashboard.',
    CARD_POS: 'POS sign-in',
    CARD_POS_CAPTION: 'Starters that let a person sign in to the POS.',
    SEARCH_PLACEHOLDER: 'Search by name',
    FILTER: 'Filter',
    APPLY: 'Apply',
    CANCEL: 'Cancel',
    STATE: 'State',
    SIGN_IN: 'Sign-in',
    ALL_STATES: 'All states',
    ANY_SIGN_IN: 'Any sign-in',
    DASHBOARD: 'Dashboard',
    POS: 'POS',
    NO_SIGN_IN: 'No sign-in',
    EVERY_STATE: 'Every state',
    COL_NAME: 'Name',
    COL_DESCRIPTION: 'Description',
    COL_STATES: 'States',
    COL_SIGN_IN: 'Sign-in',
    SIGN_BOTH: 'Dashboard, POS',
    EMPTY_TITLE: 'No starters yet',
    EMPTY_BODY: 'Nothing has been published yet. Starters appear here once they are published.',
    NO_NAME_PREFIX: 'No starter is named',
    NO_NAME_BODY: 'Nothing in the published list matches that search. Clear it to see every published starter.',
    NO_MATCH_TITLE: 'No starters match these filters',
    NO_MATCH_BODY:
        'Nothing in the published list matches the search, filters and cards you have on. Clear them to see every published starter.',
    CLEAR_SEARCH: 'Clear search',
    CLEAR_ALL: 'Clear all',
    ERROR_TITLE: 'Published starters could not be loaded',
    ERROR_BODY: 'Nothing is shown in this list until it loads. The summary above is not affected.',
    RETRY: 'Try again',
    REMOVE_STATE: 'Remove state filter',
    REMOVE_SIGN_IN: 'Remove sign-in filter',
    NO_STATE_MATCH: 'No state matches that name.',
    NEW_STARTER: 'New starter',
    BACK: 'Back',
    NAME: 'Name',
    DESCRIPTION: 'Description',
    REQUIRED: 'Required',
    OPTIONAL: 'Optional',
    NAME_PLACEHOLDER: 'Name this starter',
    NAME_REQUIRED: 'Give the starter a name before saving.',
    NAME_EXISTS: 'A starter with this name already exists.',
    DESC_PLACEHOLDER: 'What this starter is for',
    ADD_STATE: 'Add a state',
    CLEAR: 'Clear',
    DASH_HELP: 'Can sign in to the business dashboard.',
    POS_HELP: 'Can sign in to the POS.',
    PERMISSIONS: 'Permissions',
    SEARCH_PERMISSIONS: 'Search permissions',
    PUT_ALL_IN: 'Put all in',
    NO_PERMISSION_PREFIX: 'No permission matches',
    COPY_LINE: 'A later edit of this starter does not change a copy a shop already made.',
    SAVE: 'Save',
    SAVING: 'Saving…',
    SAVED_TITLE: 'Saved',
    SAVED_BODY: 'Shops that copy this starter from now on get what is on this form.',
    SAVE_FAILED: 'The starter was not saved.',
    SAVE_FAILED_BODY: 'Nothing changed on the published starter. Your edits are still on this form.',
    LEAVE_TITLE: 'Leave without saving?',
    LEAVE_BODY:
        'The name, description, states, sign-in, and permissions you changed are not saved. Leaving now discards them.',
    LEAVE_STAY: 'Stay on this starter',
    LEAVE_DISCARD: 'Leave and discard',
    DETAILS_ERROR: 'This starter could not be loaded.',
    CATALOGUE_ERROR: 'The permission list could not be loaded.',
    STATES_ERROR: 'The state list could not be loaded.',
    STATES_WORD: 'states',
    PICKED: 'picked',
} as const;
